import React from 'react'

import {FooterLink, FooterForm, StyledApplyButton, FooterFilterlabelWrapper} from './FilterFooter.styles'
import CustomCheckBox from '../../../checkbox'

const FilterFooterComponent = ({events, checked, i18n, savedFilters, validationErrors}) => {
  const props = {
    'name': 'tablefiltercheckbox',
    'disableProperty': false,
    'partialCheckbox': false,
    'boxStatus': checked ? 'selected' : 'default',
    'requiredProperty': false,
    'checkStatus': events.handleCheckChange
  }

  return (
    <div>
      
      <FooterLink href='/' onClick={events.handleClearClick}>
        {i18n.clearAll}
      </FooterLink>

      <StyledApplyButton onClick={events.handleApplyClick} disabled={validationErrors}>
        {i18n.applyFilter}
      </StyledApplyButton>

      {savedFilters && savedFilters.enabled && savedFilters.endpoint &&
        <FooterForm>
          <CustomCheckBox {...props} />
          <FooterFilterlabelWrapper>
            <label>
              {i18n.saveFilters}
            </label>
          </FooterFilterlabelWrapper>
        </FooterForm>
      }
    </div>
  )
}

export default FilterFooterComponent
